import { Component, Input } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, ModalController } from 'ionic-angular';
import { LottoBetpanelService, LotteryBetSlip, TicketSummary, BetPanel, BookBetService, Notify, SharedService, SessionService, MyBetsSharedService, Status, ConfigService, login, User, LotteryService } from 'baseline-lib';
import { BehaviorSubject } from 'rxjs';
import { LoginModalPage } from '../../shared/login-modal/login-modal';
import { HomePage } from '../../home/home/home';
import { Global } from '../../../global/global';
import { CustomToast } from '../../shared/services/custom-toast';
import { LotteryMenuPage } from '../lottery-menu-page/lottery-menu-page';

/**
 * Generated class for the BetslipPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-betslip',
  templateUrl: 'betslip.html',
})
export class BetslipPage 
{
  _lotteryBetSlip: LotteryBetSlip;
  _ticketSummary: TicketSummary;
  lotteryBetPanels: BetPanel[] = [];
  public _removeBetPanel = new BehaviorSubject<number>(0);
  _showMessage: boolean;
  errMessage: String;
  error: boolean;
  httplink:string;
  loginModel: login;
  @Input() appType;
  unautherisedStatus: any;
  currencySymbol: string;


  constructor(public navCtrl: NavController,private _myBetssharedService: MyBetsSharedService,
    public loadingCtrl: LoadingController, public _sharedService: SharedService, 
    public navParams: NavParams,public _lottoBetpanelService: LottoBetpanelService,
    private _bookBetService: BookBetService,private toast: CustomToast,
    public globalData:Global, public modalCtrl : ModalController,
    public _sessionService : SessionService, public _configService : ConfigService,
    public _lotteryService : LotteryService) 
  {
    this._lotteryBetSlip = new LotteryBetSlip();
    this._lotteryBetSlip = this._lottoBetpanelService.lotteryBetSlip;
    this._ticketSummary = new TicketSummary();
    this.currencySymbol = this._sharedService._sessionService.getCurrenySymbol();
  }

  ngOnInit() 
  {

    this.loginModel =  new login('', '', this._configService.isplayerLogin(), '');

    this.lotteryBetPanels = this._lottoBetpanelService.getPanels();
    
    // check if booked bet is available on router change

    if (this._bookBetService.checkBookBetTicket)
      this._lottoBetpanelService.processCheckBetsData(this._bookBetService.checkBookBetTicket);

    //subscript to load betslip if check book bet data available
    this._lottoBetpanelService.lotteryBookBetPanelAvlbl.subscribe(data => {
      this._lotteryBetSlip = this._lottoBetpanelService.lotteryBetSlip;
      console.log("Lottery Bet Panels Are ",this._lotteryBetSlip.betpanels);
      //console.log(this._lotteryBetSlip);
    });

    //subscript to book a load bet modal msg toggle
    this._lottoBetpanelService.loadBookBetMsg.subscribe(data => {

      this._lottoBetpanelService._notify = new Notify();
      this._lottoBetpanelService._notify = data;
    });

    console.log(this._lotteryService.extraBetOption);
  }

  removeBetPanel(panel) 
  {
    this._lotteryBetSlip.removePanel(panel);
    this._removeBetPanel.next(panel.pid);
  }

  placeBet() 
  {
    const loader = this.loadingCtrl.create({
      content: "Please Wait",
    });
    try 
    {
      loader.present();
      if (!this.validatebetSlip()) 
      {
        loader.dismiss();
        return;
      }
      if (this.globalData.isLoggedIn && this.globalData.authUser) 
      {
         this._lottoBetpanelService.placeBet().subscribe(
          (response: any) => 
          {
            loader.dismiss();
            //var msg = response.msg;

            //update balance.
            if(localStorage.getItem("authUser") !== null && localStorage.getItem("authUser") !== ""){
              this.globalData.authUser = <User>JSON.parse(localStorage.getItem("authUser"));
              this.globalData.authUser.balance = response.bal;
              //this.globalData.authUser.endBalance = response.ebal;
              this._sessionService.authUser = this.globalData.authUser;

              localStorage.setItem("authUser",JSON.stringify(this.globalData.authUser));
            }
           
            this._myBetssharedService._placeMyBet.next(1);
            this._sharedService.userBalanceUpdateGameType.next(response);
            this._lottoBetpanelService.clearallBetPanels();
            var successMsg = "Transaction Complete";
            this.toast.showSuccess(successMsg);

            this.navCtrl.setRoot(HomePage,{
              Menu : "lottery",
            });
          },
          error => 
          {
            if(error){
              if (error.msg) 
              {
                this.errMessage = error.msg;
                this._sharedService.errmsg = error.msg;
                this.toast.showError(this.errMessage);
                loader.dismiss();
              }
              else 
              {
                this.errMessage = error.message;
                this._sharedService.errmsg = error.message;
                if (error.errorCode) 
                {
                  if (error.errorCode == Status.unauthorised) 
                  {
                    console.log('logout emitter');
                    localStorage.clear(); //logout;
                    this.toast.showSuccess("You have been logged out successfully!")
                    this.globalData.selectedMenu = "home";
                    this.globalData.isLoggedIn = false;
                    this.globalData.authUser = new User();
                    this._lottoBetpanelService.clearallBetPanels();
                    if(this._sharedService.timerSub)
                      this._sharedService.timerSub.unsubscribe();
                    if(!this._configService.isplayerLogin())
                      this.navCtrl.setRoot(HomePage); 
                    this._sharedService.loginSubject.next(false);
                    //loader.dismiss();
                  }
                }
                loader.dismiss();
              }
            }
            else{
              this.toast.showError("INVALID PLAYER");
              localStorage.clear(); //logout;
              this.globalData.selectedMenu = "home";
              this.globalData.isLoggedIn = false;
              this.globalData.authUser = new User();
              this._lottoBetpanelService.clearallBetPanels();
              if(this._sharedService.timerSub)
                this._sharedService.timerSub.unsubscribe();
              this.navCtrl.setRoot(HomePage);
              loader.dismiss();
              this._sharedService.loginSubject.next(false);
            }
            this._lottoBetpanelService.clearallBetPanels();

          });
      } 
      else 
      {
        loader.dismiss();

        let profileModal = this.modalCtrl.create(LoginModalPage);
        profileModal.present();
    
      }
    }
    catch (err) 
    {    
      console.log(err);
      loader.dismiss();
    }
  }

  validatebetSlip(): boolean 
  {
    
    let result: boolean = true;
    for (var i = this._lotteryBetSlip.betpanels.length - 1; i >= 0; i--) 
    {      
      if (this._lotteryBetSlip.betpanels[i].sa < this._lotteryBetSlip.betpanels[i].minBetAmt) 
      {
        this.errMessage = "Min stake allowed is " + this._lotteryBetSlip.betpanels[i].minBetAmt;
        this._lotteryBetSlip.stakePerTicket = 0;
        this.toast.showError(this.errMessage);
        return result = false
      }
      else if (this._lotteryBetSlip.betpanels[i].sa > this._lotteryBetSlip.betpanels[i].maxBetAmt) 
      {
        this.errMessage = "Max stake allowed is " + this._lotteryBetSlip.betpanels[i].maxBetAmt;
        this._lotteryBetSlip.stakePerTicket = 0;
        this.toast.showError(this.errMessage);
        return result = false
      }

      if (this._lotteryBetSlip.betpanels[i].sa == 0 && this._lotteryBetSlip.minBetCost == 0)
      {
       
        this._lotteryBetSlip.stakePerTicket = 0;
        this.error = true;
        this._sharedService.err = true;
        setTimeout(() => {
          this.error = false;
          this._sharedService
            .err = false;
        }, 2000);
        return result = false;
      }
    }
    // this._lotteryBetSlip.stakePerTicket = 0;
    return result;
  }

  // showerror(msg)
  //   {
  //     let toast = this.toastCtrl.create({
  //       message: msg,
  //       duration: 1500,
  //       position: 'bottom'
  //     });

  //     toast.onDidDismiss(() => {
  //       console.log('Dismissed toast');
  //     });
    
    
  //     toast.present();
  //   }

  ionViewDidLoad() 
  {
    console.log('ionViewDidLoad BetslipPage');
  }

  public clearBetSlip() 
  {
    this._lottoBetpanelService.clearallBetPanels();
  }

  openLotteryMenuPage(){
    this.navCtrl.push(LotteryMenuPage);
  }

}



// WEBPACK FOOTER //
// ./src/app/lottery/betslip/betslip.ts